import React from "react";
import "./styles.scss";

const About = () => {
  return (
    <div className="about-page">
      {/* Background Video */}
      <video autoPlay loop muted className="background-video">
        <source src="video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Bismillah Fixed at Top */}
      

      {/* Content Section */}
      <div className="about-container">
      <div className="bismillah">بِسْمِ ٱللَّٰهِ الرَّحْمَٰنِ الرَّحِيمِ</div>
        <img
          src="logo.png"
          alt="Islamic Image"
          className="about-image"
        />
       
       <div className="about-text">
          <h2 className="about-title">About Our Naat City</h2>
          <p className="about-description">
            Welcome to Naat City, your ultimate source for spiritually uplifting and melodious Islamic naats and qawwalis. Our mission is to provide a peaceful, soulful space for every visitor by sharing the best collection of Islamic audio and video content. <br /><br />

            At Naat City, we are committed to offering high-quality, authentic, and beautifully recited naats that inspire devotion and inner peace. Whether you are looking to listen online or download your favorite naat sharif, we strive to create a seamless experience. <br /><br />

            We believe in spreading the message of love, peace, and faith through the power of Islamic poetry. Our dedicated team works consistently to keep the content fresh, meaningful, and easily accessible for all ages. <br /><br />

            Thank you for being part of our growing community. May your visit to Naat City bring barakah (blessings) to your life.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
